import React from 'react'
import {SearchToolbarForSpecificItemsSharing} from '../SearchToolBar/SearchToolbarForSpecificItemsSharing'
import SearchResultDataTable from '../SearchResultDataTable/SearchResultDataTable'
import ItemSearchModal from '../AddItemToListModal/AddItemToListModal'
import {SearchPagination} from '../../../searchPagination/SearchPagination'
import {FullSearchResult} from '../../useFullSearch'

const emptyArray: any[] = []

export const SearchResultTableForSpecificItemSharing = ({
                                                            fullSearchResult
                                                        }: {
    fullSearchResult: FullSearchResult
}) => {
    const {
        searchResult,
        searchFilters,
        search,
        searchResultControl: {
            addPageResultToSelection,
            clearPageSelection,
            isAnItemInPageSelected,
            areAllItemsInPageSelected,
            startIndex,
            endIndex,
            handleAddSingleItemToList,
            pageSize,
            addItemsToListModalVisible,
            setAddItemsToListModalVisible,
            selectedItemIds,
            handleRowSelectionChange,
            selectedItems,
        },
        page,
        handlePageChange,
        isSearchFetching,
        fullSearchParams
    } = fullSearchResult

    const itemIds = Array.from(selectedItemIds).map(id => String(id))

    return <div>
        <div className="search-results-table">
            <SearchToolbarForSpecificItemsSharing handleSelectAll={addPageResultToSelection}
                                                  handleUnselectAll={clearPageSelection}
                                                  isAnItemOnPageSelected={isAnItemInPageSelected()}
                                                  allItemsSelected={areAllItemsInPageSelected()}
                                                  selectedItemsList={selectedItems}
                                                  startIndex={startIndex}
                                                  endIndex={endIndex}
                                                  totalResultCount={searchResult?.totalElements ?? 0}/>
            <SearchResultDataTable
                definitionsToDisplay={searchResult?.definitionsToDisplay ?? []}
                list={searchResult?.elements ?? emptyArray}
                handleAddSingleItemToList={handleAddSingleItemToList}
                highlightPhrase={search?.phrase?.phraseDetail ?? ''}
                noItemMessages="There are no items shared with this guild"
                showAddToListButton={false}
                selectedItems={selectedItemIds}
                handleRowSelectionChange={handleRowSelectionChange}
                enableColumFiltering={false} // not ready
                isLoading={isSearchFetching}
                filterValues={searchFilters}
                fullSearchParams={fullSearchParams}
            />

        </div>
        <SearchPagination
            totalElements={searchResult?.totalElements || 0}
            pageSize={pageSize}
            page={page}
            handlePageChange={handlePageChange}
        />
        {addItemsToListModalVisible && (
            <ItemSearchModal
                closeModal={() => setAddItemsToListModalVisible(false)}
                itemIds={itemIds}
            />
        )}
    </div>
}
